import React from 'react'
import styled from 'styled-components'

const Label = styled.div<{ labelColor?: string }>`
  width: 7px;
  height: 30px;
  background-color: ${({ labelColor, theme }) =>
    labelColor === 'high'
      ? theme.colors.alertHigh
      : labelColor === 'medium'
      ? theme.colors.alertMedium
      : theme.colors.alertLow};
  border-radius: 0 15px 15px 0;
`

type Props = {
  alertLabel?: string
}

const AlertLabel: React.FC<Props> = (props) => {
  const { alertLabel } = props

  return <Label labelColor={alertLabel} />
}

export default AlertLabel
